import { useLocationById } from '@hakimo-ui/hakimo/data-access';
import { Alarm } from '@hakimo-ui/hakimo/types';
import { BasicPanel, QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';

interface Props {
  alarm?: Alarm;
  locationId?: string;
}

function Floorplan({ alarm, locationId }: Props) {
  const queryResult = useLocationById(locationId ? String(locationId) : '');
  const floorplanPath = alarm?.floorplanPath;

  const renderImage = (src: string) => (
    <div className="flex justify-center bg-gray-200 dark:bg-gray-900">
      <img src={src} alt="Floorplan" className="max-h-[48rem]" />
    </div>
  );

  const renderFloorplan = () => {
    if (floorplanPath) return renderImage(floorplanPath);

    if (locationId && queryResult) {
      return (
        <QueryResult queryResult={queryResult}>
          {(location) =>
            location.floor_plan ? (
              renderImage(location.floor_plan)
            ) : (
              <div className="p-6">
                <Alert>Floorplan not available</Alert>
              </div>
            )
          }
        </QueryResult>
      );
    }

    return (
      <div className="p-6">
        <Alert>Floorplan not available</Alert>
      </div>
    );
  };

  return <BasicPanel title="Floorplan">{renderFloorplan()}</BasicPanel>;
}

export default Floorplan;
